import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '../Button';
import IconBadge from '../IconBadge';
import './SearchPill.scss';

const SearchPill = ({
  url,
  iconName,
  name,
  onClick,
  shortName,
}) => (
  <Button
    className="SearchPill"
    onClick={onClick}
    variant="no-style"
  >
    <IconBadge
      url={iconName}
      label={name}
      size="54"
      bgToSvgRatio="2"
      name={url === 'collection_14' ? 'gda' : name}
      title={name}
      background="#fafafa"
    />
    <p className={cx('SearchPill__label', {
      'SearchPill__label--gda': url === 'collection_14',
    })}
    >
      {shortName || name}
    </p>
  </Button>
);

SearchPill.propTypes = {
  url: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  shortName: PropTypes.string.isRequired,
};

SearchPill.displayName = 'SearchPill';
export default SearchPill;
